import axios from 'axios'

import { API_ENDPOINT, COOKIE_NAME } from './constants'

const getCookie = (name: string): string | null => {
  const nameLenPlus = (name.length + 1)
  return document.cookie
    .split(';')
    .map(c => c.trim())
    .filter(cookie => {
      return cookie.substring(0, nameLenPlus) === `${name}=`
    })
    .map(cookie => {
      return decodeURIComponent(cookie.substring(nameLenPlus))
    })[0] || null
}

export const submitRequest = async <T>(method: string, endpoint: string, payload: any = undefined, params: any = undefined, headers: Record<string, string> | undefined = undefined): Promise<T> => {
  const token = getCookie(COOKIE_NAME)
  const instance = axios.create()
  let data: T
  try {
    ({ data } = await instance<T>({
      url: `${API_ENDPOINT}/${endpoint}`,
      method,
      data: payload,
      params,
      headers: {
        ...headers,
        Authorization: token != null ? `Bearer ${token}` : undefined
      }
    }))
  } catch (e: any) {
    if (e.response != null) {
      throw new Error(e.response.data.message)
    } else {
      throw new Error(e)
    }
  }
  return data
}
